/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ListPayoutsResponse } from '../models';
// @ts-ignore
import type { PayoutDetailResponse } from '../models';
/**
 * MerchantPayoutReportingApi - axios parameter creator
 * @export
 */
export const MerchantPayoutReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Exports the merchant\'s payout detail for a specific settlement date as a PDF document.  **File Format:** - Filename format: `payout_detail_{merchantId}_{activityDate}.pdf` - Example: `payout_detail_01HQWX_2026-02-24.pdf` 
         * @summary Export payout detail for a merchant as PDF
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {ExportMerchantPayoutDetailFormatEnum} format Export format: - pdf: PDF document (application/pdf) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMerchantPayoutDetail: async (merchantId: string, activityDate: string, format: ExportMerchantPayoutDetailFormatEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('exportMerchantPayoutDetail', 'merchantId', merchantId)
            // verify required parameter 'activityDate' is not null or undefined
            assertParamExists('exportMerchantPayoutDetail', 'activityDate', activityDate)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportMerchantPayoutDetail', 'format', format)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/payouts/{activityDate}/export`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"activityDate"}}`, encodeURIComponent(String(activityDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exports payout summary data for a specific merchant in the specified format (CSV or XLSX). Uses the same filtering as the merchant payout list endpoint.  **Export Limits:** - Maximum 10,000 rows per export request  **File Format:** - Filename format: `payouts_{startDate}_to_{endDate}.{format}` - Example: `payouts_2026-02-01_to_2026-02-28.csv` 
         * @summary Export payout summaries for a merchant as CSV or Excel
         * @param {string} merchantId Merchant identifier
         * @param {ExportMerchantPayoutsFormatEnum} format Export format: - csv: Comma-separated values (text/csv) - xlsx: Excel spreadsheet (application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) 
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {ExportMerchantPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ExportMerchantPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMerchantPayouts: async (merchantId: string, format: ExportMerchantPayoutsFormatEnum, startDate: string, endDate: string, sortBy?: ExportMerchantPayoutsSortByEnum, sortDirection?: ExportMerchantPayoutsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('exportMerchantPayouts', 'merchantId', merchantId)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportMerchantPayouts', 'format', format)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('exportMerchantPayouts', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('exportMerchantPayouts', 'endDate', endDate)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/payouts/export`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a full financial breakdown for the merchant\'s payout on a given settlement date, including gross revenue, refunds, chargebacks, fee breakdown, and individual refund/chargeback transactions.  **Net Payout Formula:** `grossRevenue - fullRefunds - partialRefunds - serviceFees - platformFees - chargebackFees - chargebacks` 
         * @summary Get detailed payout breakdown for a merchant on a specific date
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantPayoutDetail: async (merchantId: string, activityDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantPayoutDetail', 'merchantId', merchantId)
            // verify required parameter 'activityDate' is not null or undefined
            assertParamExists('getMerchantPayoutDetail', 'activityDate', activityDate)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/payouts/{activityDate}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"activityDate"}}`, encodeURIComponent(String(activityDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated payout summaries for a single merchant, filtered by date range. Each row represents the merchant\'s settled activity for one day.  **Access Control:** - backoffice.admin: Can query any merchant - partner.admin / partner.user: Scoped to merchants within their partner organisation - merchant.admin / merchant.user: Scoped to their own merchant only  **Date Range:** Maximum 90 days. End date cannot be in the future. 
         * @summary List payout summaries for a specific merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {ListMerchantPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ListMerchantPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantPayouts: async (merchantId: string, startDate: string, endDate: string, page?: number, size?: number, sortBy?: ListMerchantPayoutsSortByEnum, sortDirection?: ListMerchantPayoutsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listMerchantPayouts', 'merchantId', merchantId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('listMerchantPayouts', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('listMerchantPayouts', 'endDate', endDate)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/payouts`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantPayoutReportingApi - functional programming interface
 * @export
 */
export const MerchantPayoutReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantPayoutReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * Exports the merchant\'s payout detail for a specific settlement date as a PDF document.  **File Format:** - Filename format: `payout_detail_{merchantId}_{activityDate}.pdf` - Example: `payout_detail_01HQWX_2026-02-24.pdf` 
         * @summary Export payout detail for a merchant as PDF
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {ExportMerchantPayoutDetailFormatEnum} format Export format: - pdf: PDF document (application/pdf) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMerchantPayoutDetail(merchantId: string, activityDate: string, format: ExportMerchantPayoutDetailFormatEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMerchantPayoutDetail(merchantId, activityDate, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantPayoutReportingApi.exportMerchantPayoutDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exports payout summary data for a specific merchant in the specified format (CSV or XLSX). Uses the same filtering as the merchant payout list endpoint.  **Export Limits:** - Maximum 10,000 rows per export request  **File Format:** - Filename format: `payouts_{startDate}_to_{endDate}.{format}` - Example: `payouts_2026-02-01_to_2026-02-28.csv` 
         * @summary Export payout summaries for a merchant as CSV or Excel
         * @param {string} merchantId Merchant identifier
         * @param {ExportMerchantPayoutsFormatEnum} format Export format: - csv: Comma-separated values (text/csv) - xlsx: Excel spreadsheet (application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) 
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {ExportMerchantPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ExportMerchantPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMerchantPayouts(merchantId: string, format: ExportMerchantPayoutsFormatEnum, startDate: string, endDate: string, sortBy?: ExportMerchantPayoutsSortByEnum, sortDirection?: ExportMerchantPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMerchantPayouts(merchantId, format, startDate, endDate, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantPayoutReportingApi.exportMerchantPayouts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a full financial breakdown for the merchant\'s payout on a given settlement date, including gross revenue, refunds, chargebacks, fee breakdown, and individual refund/chargeback transactions.  **Net Payout Formula:** `grossRevenue - fullRefunds - partialRefunds - serviceFees - platformFees - chargebackFees - chargebacks` 
         * @summary Get detailed payout breakdown for a merchant on a specific date
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantPayoutDetail(merchantId: string, activityDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantPayoutDetail(merchantId, activityDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantPayoutReportingApi.getMerchantPayoutDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated payout summaries for a single merchant, filtered by date range. Each row represents the merchant\'s settled activity for one day.  **Access Control:** - backoffice.admin: Can query any merchant - partner.admin / partner.user: Scoped to merchants within their partner organisation - merchant.admin / merchant.user: Scoped to their own merchant only  **Date Range:** Maximum 90 days. End date cannot be in the future. 
         * @summary List payout summaries for a specific merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {ListMerchantPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ListMerchantPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMerchantPayouts(merchantId: string, startDate: string, endDate: string, page?: number, size?: number, sortBy?: ListMerchantPayoutsSortByEnum, sortDirection?: ListMerchantPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPayoutsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMerchantPayouts(merchantId, startDate, endDate, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantPayoutReportingApi.listMerchantPayouts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantPayoutReportingApi - factory interface
 * @export
 */
export const MerchantPayoutReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantPayoutReportingApiFp(configuration)
    return {
        /**
         * Exports the merchant\'s payout detail for a specific settlement date as a PDF document.  **File Format:** - Filename format: `payout_detail_{merchantId}_{activityDate}.pdf` - Example: `payout_detail_01HQWX_2026-02-24.pdf` 
         * @summary Export payout detail for a merchant as PDF
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {ExportMerchantPayoutDetailFormatEnum} format Export format: - pdf: PDF document (application/pdf) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMerchantPayoutDetail(merchantId: string, activityDate: string, format: ExportMerchantPayoutDetailFormatEnum, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportMerchantPayoutDetail(merchantId, activityDate, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Exports payout summary data for a specific merchant in the specified format (CSV or XLSX). Uses the same filtering as the merchant payout list endpoint.  **Export Limits:** - Maximum 10,000 rows per export request  **File Format:** - Filename format: `payouts_{startDate}_to_{endDate}.{format}` - Example: `payouts_2026-02-01_to_2026-02-28.csv` 
         * @summary Export payout summaries for a merchant as CSV or Excel
         * @param {string} merchantId Merchant identifier
         * @param {ExportMerchantPayoutsFormatEnum} format Export format: - csv: Comma-separated values (text/csv) - xlsx: Excel spreadsheet (application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) 
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {ExportMerchantPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ExportMerchantPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMerchantPayouts(merchantId: string, format: ExportMerchantPayoutsFormatEnum, startDate: string, endDate: string, sortBy?: ExportMerchantPayoutsSortByEnum, sortDirection?: ExportMerchantPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportMerchantPayouts(merchantId, format, startDate, endDate, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a full financial breakdown for the merchant\'s payout on a given settlement date, including gross revenue, refunds, chargebacks, fee breakdown, and individual refund/chargeback transactions.  **Net Payout Formula:** `grossRevenue - fullRefunds - partialRefunds - serviceFees - platformFees - chargebackFees - chargebacks` 
         * @summary Get detailed payout breakdown for a merchant on a specific date
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantPayoutDetail(merchantId: string, activityDate: string, options?: RawAxiosRequestConfig): AxiosPromise<PayoutDetailResponse> {
            return localVarFp.getMerchantPayoutDetail(merchantId, activityDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated payout summaries for a single merchant, filtered by date range. Each row represents the merchant\'s settled activity for one day.  **Access Control:** - backoffice.admin: Can query any merchant - partner.admin / partner.user: Scoped to merchants within their partner organisation - merchant.admin / merchant.user: Scoped to their own merchant only  **Date Range:** Maximum 90 days. End date cannot be in the future. 
         * @summary List payout summaries for a specific merchant
         * @param {string} merchantId Merchant identifier
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {ListMerchantPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ListMerchantPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantPayouts(merchantId: string, startDate: string, endDate: string, page?: number, size?: number, sortBy?: ListMerchantPayoutsSortByEnum, sortDirection?: ListMerchantPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<ListPayoutsResponse> {
            return localVarFp.listMerchantPayouts(merchantId, startDate, endDate, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantPayoutReportingApi - object-oriented interface
 * @export
 * @class MerchantPayoutReportingApi
 * @extends {BaseAPI}
 */
export class MerchantPayoutReportingApi extends BaseAPI {
    /**
     * Exports the merchant\'s payout detail for a specific settlement date as a PDF document.  **File Format:** - Filename format: `payout_detail_{merchantId}_{activityDate}.pdf` - Example: `payout_detail_01HQWX_2026-02-24.pdf` 
     * @summary Export payout detail for a merchant as PDF
     * @param {string} merchantId Merchant identifier
     * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
     * @param {ExportMerchantPayoutDetailFormatEnum} format Export format: - pdf: PDF document (application/pdf) 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantPayoutReportingApi
     */
    public exportMerchantPayoutDetail(merchantId: string, activityDate: string, format: ExportMerchantPayoutDetailFormatEnum, options?: RawAxiosRequestConfig) {
        return MerchantPayoutReportingApiFp(this.configuration).exportMerchantPayoutDetail(merchantId, activityDate, format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exports payout summary data for a specific merchant in the specified format (CSV or XLSX). Uses the same filtering as the merchant payout list endpoint.  **Export Limits:** - Maximum 10,000 rows per export request  **File Format:** - Filename format: `payouts_{startDate}_to_{endDate}.{format}` - Example: `payouts_2026-02-01_to_2026-02-28.csv` 
     * @summary Export payout summaries for a merchant as CSV or Excel
     * @param {string} merchantId Merchant identifier
     * @param {ExportMerchantPayoutsFormatEnum} format Export format: - csv: Comma-separated values (text/csv) - xlsx: Excel spreadsheet (application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) 
     * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {ExportMerchantPayoutsSortByEnum} [sortBy] Field to sort by
     * @param {ExportMerchantPayoutsSortDirectionEnum} [sortDirection] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantPayoutReportingApi
     */
    public exportMerchantPayouts(merchantId: string, format: ExportMerchantPayoutsFormatEnum, startDate: string, endDate: string, sortBy?: ExportMerchantPayoutsSortByEnum, sortDirection?: ExportMerchantPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return MerchantPayoutReportingApiFp(this.configuration).exportMerchantPayouts(merchantId, format, startDate, endDate, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a full financial breakdown for the merchant\'s payout on a given settlement date, including gross revenue, refunds, chargebacks, fee breakdown, and individual refund/chargeback transactions.  **Net Payout Formula:** `grossRevenue - fullRefunds - partialRefunds - serviceFees - platformFees - chargebackFees - chargebacks` 
     * @summary Get detailed payout breakdown for a merchant on a specific date
     * @param {string} merchantId Merchant identifier
     * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantPayoutReportingApi
     */
    public getMerchantPayoutDetail(merchantId: string, activityDate: string, options?: RawAxiosRequestConfig) {
        return MerchantPayoutReportingApiFp(this.configuration).getMerchantPayoutDetail(merchantId, activityDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated payout summaries for a single merchant, filtered by date range. Each row represents the merchant\'s settled activity for one day.  **Access Control:** - backoffice.admin: Can query any merchant - partner.admin / partner.user: Scoped to merchants within their partner organisation - merchant.admin / merchant.user: Scoped to their own merchant only  **Date Range:** Maximum 90 days. End date cannot be in the future. 
     * @summary List payout summaries for a specific merchant
     * @param {string} merchantId Merchant identifier
     * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {ListMerchantPayoutsSortByEnum} [sortBy] Field to sort by
     * @param {ListMerchantPayoutsSortDirectionEnum} [sortDirection] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantPayoutReportingApi
     */
    public listMerchantPayouts(merchantId: string, startDate: string, endDate: string, page?: number, size?: number, sortBy?: ListMerchantPayoutsSortByEnum, sortDirection?: ListMerchantPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return MerchantPayoutReportingApiFp(this.configuration).listMerchantPayouts(merchantId, startDate, endDate, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportMerchantPayoutDetailFormatEnum = {
    Pdf: 'pdf'
} as const;
export type ExportMerchantPayoutDetailFormatEnum = typeof ExportMerchantPayoutDetailFormatEnum[keyof typeof ExportMerchantPayoutDetailFormatEnum];
/**
 * @export
 */
export const ExportMerchantPayoutsFormatEnum = {
    Csv: 'csv',
    Xlsx: 'xlsx'
} as const;
export type ExportMerchantPayoutsFormatEnum = typeof ExportMerchantPayoutsFormatEnum[keyof typeof ExportMerchantPayoutsFormatEnum];
/**
 * @export
 */
export const ExportMerchantPayoutsSortByEnum = {
    MerchantName: 'merchantName',
    ActivityDate: 'activityDate',
    NetPayoutCents: 'netPayoutCents',
    TotalSales: 'totalSales'
} as const;
export type ExportMerchantPayoutsSortByEnum = typeof ExportMerchantPayoutsSortByEnum[keyof typeof ExportMerchantPayoutsSortByEnum];
/**
 * @export
 */
export const ExportMerchantPayoutsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ExportMerchantPayoutsSortDirectionEnum = typeof ExportMerchantPayoutsSortDirectionEnum[keyof typeof ExportMerchantPayoutsSortDirectionEnum];
/**
 * @export
 */
export const ListMerchantPayoutsSortByEnum = {
    MerchantName: 'merchantName',
    ActivityDate: 'activityDate',
    NetPayoutCents: 'netPayoutCents',
    TotalSales: 'totalSales'
} as const;
export type ListMerchantPayoutsSortByEnum = typeof ListMerchantPayoutsSortByEnum[keyof typeof ListMerchantPayoutsSortByEnum];
/**
 * @export
 */
export const ListMerchantPayoutsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListMerchantPayoutsSortDirectionEnum = typeof ListMerchantPayoutsSortDirectionEnum[keyof typeof ListMerchantPayoutsSortDirectionEnum];
